/**
 * Javascript specific to displaying tooltips and popovers
 * Popovers: https://getbootstrap.com/docs/4.0/components/popovers/
 * ToolTips: https://getbootstrap.com/docs/4.0/components/tooltips/
 */

(function (window, document, $) {
	'use strict';

	// General use of Tooltips
	$( '[data-toggle="tooltip"]' ).tooltip({
		trigger:'click',
		html: true,
		offset: '5,10'
	});

	//General use of Popovers
	$('.mstar-popover').popover({
		trigger: 'click',
		html: true,
		offset: '5,10'
	})

	// Close when clicked outside of tooltip/popover
	$(document).on('click', function(event) {
		var $target = $(event.target);
		if (!$target.closest('.tooltip').length && !$target.closest('[data-toggle="tooltip"]').length) {
			$('.tooltip').tooltip('hide');
		}
		if (!$target.closest('.popover').length && !$target.closest('[data-toggle="popover"]').length) {
			$('.popover').popover('hide');
		}
	});

	// Close button for Popovers.
	$(document).on("click", ".popover .close" , function(event){
		event.preventDefault();
		$(this).parents(".popover").popover('hide');
	});

})( window, document, jQuery );